import {Inject, Injectable, NgZone} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {NEW_USER_CONFIG} from "../../config/api";
import {HttpClient} from "@angular/common/http";
import {LoaderService} from "../loader.service";

@Injectable({
    providedIn: 'root'
})
export class NewUserService {
    private config = NEW_USER_CONFIG;

    constructor(private http: HttpClient,
                private loaderService: LoaderService) {

    }

    sell(phone, amount) {
        this.loaderService.show();
        return this.http.post<any>(this.config.save, {phone, amount});
    }
}
